module.exports = __webpack_public_path__ + "img/img109.ebef904e.svg";